module.exports = __webpack_public_path__ + "static/zuri-mejzlik-logo-35e0e02d7f6b7713fccc2bd6d4ec665e.jpg";